export default __webpack_public_path__ + "static/media/hamburger-info.0969e31a.svg";